import React from 'react';
import { Card, CardHeader, CardContent } from '@mui/material';
import { Timer } from '@mui/icons-material';
import ReadTimeCategoryChart from '../charts/ReadTimeCategoryChart';
import ReadTimeInfo from './ReadTimeInfo';
import RichTooltip from '../../RichTooltip';

const CategoryData = data => {
    if (!data) {
        return null;
    }

    return Object.entries(
        Object.fromEntries(
            ['glance', 'skim', 'read'].map(key => [
                key, Object.values(data).reduce((sum, d) => sum + d[key], 0)
            ])
        )
    ).map(([k, v]) => [k[0].toUpperCase() + k.slice(1), v]);
};

const ReadTimeCategoryCard = ({ a, b, aColour, bColour }) => {
    const aData = CategoryData(a.readTimesByDevice);
    const bData = b ? CategoryData(b.readTimesByDevice) : null;

    return (
        <Card sx={{ height: '100%', m: 0, p: 0 }}>
            <CardHeader
                sx={{
                    m: 0,
                    py: 1
                }}
                title="Read Time"
                slotProps={{
                    title: {
                        variant: 'h6',
                        fontWeight: 'normal'
                    }
                }}
                avatar={<Timer />}
                action={(
                    <RichTooltip>
                        <ReadTimeInfo />
                    </RichTooltip>
                )}
            />
            <CardContent
                sx={{
                    m: 0,
                    px: 2,
                    py: 0,
                    '&:last-child': {
                        paddingBottom: 2
                    }
                }}
            >
                <ReadTimeCategoryChart
                    a={aData}
                    b={bData}
                    aColour={aColour}
                    bColour={bColour}
                />
            </CardContent>
        </Card>
    );
};

export default ReadTimeCategoryCard;